import { useGlobalStore } from "./globalStore";
import { useAllListeners } from "./hooks/useAllListeners";
import { Dialogs } from "./widgets/dialog";

function App() {
	const version = useGlobalStore((state) => state.version);

	useAllListeners();

	return (
		<div>
			<div id="main">
				<div className="button-list">
					<Dialogs />
					<div className="version">ver{version}</div>
				</div>
			</div>
		</div>
	);
}

export { App };
